import { useContext } from 'react';
import { MainContext } from '../../contexts/main';
import { timestampToLongDate } from '@educaplay/app-core/time';
import { getText } from '@educaplay/app-core/language';
import { getPremiumURL } from '../../helpers/urls';
import { BlockInfoLicense } from '../blocks/BlockInfoLicense';
import { BlockInvoices } from '../blocks/BlockInvoices';
import { BlockNotifications } from '../blocks/BlockNotifications';
import { BlockLostRenewalNotice } from '../blocks/BlockLostRenewalNotice';
import { BlockTitle } from '../blocks/BlockTitle';
import { SVG_back } from '../elements/SVG';

export const ScreenInfo = () => {

    const { environment, mainReducer } = useContext( MainContext );

    const handleGoToPremium = () => {
        window.location.href = getPremiumURL(environment, 'my_plan');
    }

    return  <>
            <section className="e__plns__lst__main">
                <BlockTitle title="plan" />
                <BlockNotifications />
                <BlockLostRenewalNotice />
                <div className="e__plns__lst__hd">
                    <div className="e__plns__hdg__wrp">
                        <div className='e__plns__hdg__wrp__lst'>
                            {((mainReducer.state.subLicense !== false) && (mainReducer.state.subLicense <= mainReducer.state.currentLicense.id)) &&
                                <>
                                    <div className='e__plns__hdg__wrp__lst__plan'>
                                        <div className="e__plns__lst__hd__hdg">{ getText('plan_asignado') }:</div>
                                        <BlockInfoLicense license={ { id: mainReducer.state.subLicense } } />
                                        <span className="e__plns__lst__hd__ico">
                                            <SVG_back />
                                        </span>
                                    </div>
                                </>
                            }
                            {((mainReducer.state.inProgressLicense.id == mainReducer.state.currentLicense.id) && (mainReducer.state.inProgressLicense.periodicity == mainReducer.state.currentLicense.periodicity) && (mainReducer.state.inProgressLicense.licenses == mainReducer.state.currentLicense.licenses)) ?
                                <>
                                    <div className='e__plns__hdg__wrp__lst__plan'>
                                        <div className="e__plns__lst__hd__hdg">{ getText('plan_contratado') }:</div>
                                        <BlockInfoLicense license={ mainReducer.state.currentLicense } />
                                        <span className="e__plns__lst__hd__ico">
                                            <SVG_back />
                                        </span>
                                    </div>
                                </>
                            :
                                <>
                                    <div className='e__plns__hdg__wrp__lst__plan'>
                                        <div className="e__plns__lst__hd__hdg">{ getText('plan_contratado') }:</div>
                                        <BlockInfoLicense license={ mainReducer.state.inProgressLicense } />
                                        <span className="e__plns__lst__hd__ico">
                                            <SVG_back />
                                        </span>
                                    </div>
                                    <div className='e__plns__hdg__wrp__lst__plan e__plns__hdg__wrp__lst__plan--column'>
                                        <BlockInfoLicense license={ mainReducer.state.currentLicense } />
                                        <div className="e__plns__lst__hd__hdg">{ getText('a_partir_de') } { timestampToLongDate(mainReducer.state.inProgressLicense.expiration) }:</div>
                                        <span className="e__plns__lst__hd__ico">
                                            <SVG_back />
                                        </span>
                                    </div>
                                </>
                            }
                            {((mainReducer.state.subLicense !== false) && (mainReducer.state.subLicense > mainReducer.state.currentLicense.id)) &&
                                <>
                                    <div className='e__plns__hdg__wrp__lst__plan'>
                                        <div className="e__plns__lst__hd__hdg">{ getText('plan_asignado') }:</div>
                                        <BlockInfoLicense license={ { id: mainReducer.state.subLicense } } />
                                        <span className="e__plns__lst__hd__ico">
                                            <SVG_back />
                                        </span>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
                <button className="e-btn e-btn--premium e-btn--lg" onClick={ handleGoToPremium }>
                    <span className="e-btn__txt">{ getText('mejorar_plan') }</span>
                </button>
            </section>
            <BlockInvoices />
            </>
    
}